import type { ReactNode } from "react";
import type { ActionFunction, LoaderFunction } from "@remix-run/node";
import { Form, redirect, useActionData } from "@remix-run/react";
import { LoginForm } from "~/components/forms/login-form";
import { authenticator } from "~/services/authenticator";
import { ZodError } from "zod";

import { sessionStorage } from "../services/session.server";

export const action: ActionFunction = async ({ request }) => {
  try {
    const user = await authenticator.authenticate("user-pass", request);

    if (!user?.id) {
      return { error: "Virheellinen sähköposti tai salasana" };
    }

    const session = await sessionStorage.getSession(
      request.headers.get("cookie")
    );
    session.set("user", user);

    // Redirect to appropriate dashboard based on role
    let redirectUrl = "/coach"; // default for individual_coach
    if (user.role === "group_coach" || user.role === "work_coach") {
      redirectUrl = "/groupCoach";
    } else if (user.role === "administrator") {
      redirectUrl = "/admin";
    }

    return redirect(redirectUrl, {
      headers: { "Set-Cookie": await sessionStorage.commitSession(session) },
    });
  } catch (error) {
    let errorMessage;

    if (error instanceof ZodError) {
      errorMessage = "Virheellinen sähköposti tai salasana";
    } else if (error instanceof Error) {
      errorMessage = "Virheellinen sähköposti tai salasana";
    }

    return { error: errorMessage };
  }
};

export const loader: LoaderFunction = async ({ request }) => {
  const session = await sessionStorage.getSession(
    request.headers.get("cookie")
  );

  const user = session.get("user");

  if (user) {
    // Redirect to appropriate dashboard based on role
    let redirectUrl = "/coach"; // default for individual_coach
    if (user.role === "group_coach" || user.role === "work_coach") {
      redirectUrl = "/groupCoach";
    } else if (user.role === "administrator") {
      redirectUrl = "/admin";
    }

    throw redirect(redirectUrl);
  }
  return null;
};

export default function LoginPage(): ReactNode {
  const actionData = useActionData<{ error: string }>();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Form method="post">
        <LoginForm error={actionData?.error} />
      </Form>
    </div>
  );
}
